/**
 * Styles para /administracao/integracoes-cad.
 * Reusa o vocabulario visual de /administracao/importacoes para consistencia.
 */
import styled from "styled-components";

import { getToneTokens } from "../../../styles/shared";

export const Card = styled.section`
  background: ${({ theme }) => theme.surface};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 12px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SectionTitle = styled.h3`
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${({ theme }) => theme.textSecondary};
`;

export const Row = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
`;

export const Select = styled.select`
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.textPrimary};
  font-size: 0.88rem;
`;

export const Input = styled.input`
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.textPrimary};
  font-size: 0.88rem;
  flex: 1;
  min-width: 180px;
`;

export const TableWrapper = styled.div`
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  /* Bugfix #13: overflow-x clip (nao auto-promove overflow-y) */
  overflow-x: clip;
`;

export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 0.85rem;

  th,
  td {
    text-align: left;
    padding: 10px 12px;
    border-bottom: 1px solid ${({ theme }) => theme.border};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  th {
    font-size: 0.68rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: ${({ theme }) => theme.textSecondary};
    font-weight: 600;
    background: ${({ theme }) => theme.surfaceAlt};
  }
`;

export const Pill = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  background: ${({ theme, $tone = "neutral" }) => getToneTokens(theme, $tone).background};
  color: ${({ theme, $tone = "neutral" }) => getToneTokens(theme, $tone).text};
  border: 1px solid ${({ theme, $tone = "neutral" }) => getToneTokens(theme, $tone).border};
`;

export const ErrorBox = styled.div`
  padding: 12px 14px;
  border-radius: 8px;
  background: ${({ theme }) => theme.dangerSurface};
  color: ${({ theme }) => theme.dangerText};
  border: 1px solid ${({ theme }) => theme.dangerBorder};
  font-size: 0.85rem;
`;

export const InfoBox = styled.div`
  padding: 12px 14px;
  border-radius: 8px;
  background: ${({ theme }) => theme.infoSurface};
  color: ${({ theme }) => theme.infoText};
  border: 1px solid ${({ theme }) => theme.infoBorder};
  font-size: 0.85rem;
`;

export const HelpText = styled.p`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.textSecondary};
  line-height: 1.5;
  margin: 0;
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.textPrimary};

  span {
    font-size: 0.72rem;
    color: ${({ theme }) => theme.textSecondary};
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 600;
  }
`;

export const EmptyState = styled.div`
  padding: 24px;
  text-align: center;
  color: ${({ theme }) => theme.textSecondary};
  font-size: 0.88rem;
`;
